/*
 * fn: setAuthentication
 *
 * Sets a custom field for all following GA events for auth state
 *
 */
import ReactGA from 'react-ga4'

import { IS_ANALYTICS_ENABLED } from '@/defs/analytics'

export const setAuthentication = (authentication: 'authenticated' | 'unauthenticated') => {
  if (!IS_ANALYTICS_ENABLED) return

  ReactGA.set({ authentication })
}
